<template>
  <div id="app">
    <transition name="fade" mode="out-in">
      <keep-alive :include="/__need_cache__/">
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'app',
  data() {
    return {};
  },
  created() {
    this.isLocalStorageSupported();
    this.andriodInputBug();
    this.isCookiesSupported();
    this.fitIPhoneX();
    /**
     * 处理iOS 微信客户端6.7.4 键盘收起页面未下移bug
     */
    let iosReg = /iphone|ipod|ipad/i;
    iosReg.test(navigator.appVersion) &&
      document.addEventListener(
        'blur',
        e => {
          ['input', 'textarea'].includes(e.target.localName) &&
            document.body.scrollIntoView(false);
        },
        true
      );
  },
  methods: {
    //解决安卓点击input，弹出键盘挡住input的问题
    andriodInputBug() {
      if (/Android/gi.test(navigator.userAgent)) {
        window.addEventListener('resize', function() {
          if (
            document.activeElement.tagName == 'INPUT' ||
            document.activeElement.tagName == 'TEXTAREA'
          ) {
            window.setTimeout(function() {
              document.activeElement.scrollIntoViewIfNeeded();
            }, 0);
          }
        });
      }
    },

    isLocalStorageSupported() {
      var testKey = 'test',
        storage = window.localStorage;
      try {
        storage.setItem(testKey, 'testValue');
        storage.removeItem(testKey);
        return true;
      } catch (error) {
        alert('您处于无痕浏览,无法为您提供良好的体验，请切换正常模式访问');
        return false;
      }
    },

    isCookiesSupported() {
      let cookieEnabled = navigator.cookieEnabled ? true : false;
      if (!cookieEnabled) {
        alert('您的隐私设置关闭了cookie功能，请开启该功能');
        return false;
      }
    },
    //铺满iphoneX
    fitIPhoneX() {
      // <meta name="viewport" content="viewport-fit=cover">
      let meta = document.querySelector('meta[name="viewport"]');
      if (meta) {
        let content = meta.getAttribute('content');
        meta.setAttribute('content', content + ', viewport-fit=cover');
      }
      this.fommatIPhoneXBodyPadding();
      window.onresize = this.fommatIPhoneXBodyPadding;
    },
    fommatIPhoneXBodyPadding() {
      let unit = process.env.VUE_APP_USE_VW == 1 ? 'vw' : 'rem';
      document.body.style.padding = '';
      let bodyPadding = getComputedStyle(document.body, false)['padding'];
      let fs = process.env.VUE_APP_USE_VW == 1 ? 7.5 : 75;
      let calcedPadding = bodyPadding
        .split(/\s+/)
        .map(e => {
          let num = e.replace('px', '');
          return num / fs + unit;
        })
        .join(' ');
      document.body.style.padding = calcedPadding;
    }
  }
};
</script>

<style lang="less">
// Then, you can use constant() for iOS 11.0–11.2 and env() for iOS versions higher than 11.2.
html,
body {
  width: 100%;
  height: 100%;
}
body {
  box-sizing: border-box;
  padding: 0;
  padding: constant(safe-area-inset-top) constant(safe-area-inset-right)
    constant(safe-area-inset-bottom) constant(safe-area-inset-left); //适配iPhoneX
  padding: env(safe-area-inset-top) env(safe-area-inset-right)
    env(safe-area-inset-bottom) env(safe-area-inset-left); //适配iPhoneX
}
* {
  flex-shrink: 0;
}

#app {
  width: 750px;
  margin: 0 auto;
  height: 100%;
  -webkit-overflow-scrolling: touch;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > *:nth-child(1) {
    flex-grow: 1;
    flex-shrink: 0;
  }
}
</style>
<style lang="less" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
